/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { theme } from "styles/theme";
import { useEffect, useState } from "react";
import { TDevice } from "apis/visitors/device";
import UI from "@mile-meeting/mile-ui";
import AlertModal from "uis/modal/alert-modal";
import { updateWalkInVisitActive } from "apis/visitors/setting/walk-in-visit";
import Tab from "../../tab";
import SettingManager from "./setting-host";
import MeetingPurpose from "./meeting-purpose";
import VisitInfoOption from "./visit-info-option";
import { getMessengers } from "apis/messangers";

const Title = styled.p`
  color: var(--alias-color-label-normal);
  font-size: 18px;
  font-weight: 700;
  line-height: 26px;
`;
const GuideContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  line-height: 22px;
`;
const Guide = styled.p`
  font-weight: 500;
  font-size: 15px;
  color: var(--alias-color-label-alternative);
  line-height: 22px;
  vertical-align: middle;
`;
const GuideLink = styled.a`
  font-weight: 700;
  font-size: 14px;
  color: var(--alias-color-primary-normal);
  line-height: 22px;
  vertical-align: bottom;
`;

const ActiveContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-content: center;
  height: 84px;
  align-items: center;
  padding: 0 40px;
  background-color: ${theme.neutral50};
`;

const WalkInVisit = ({ device, onChange }: { device: TDevice; onChange?: () => void }) => {
  const [isOpenAlertModal, setIsOpenAlertModal] = useState<boolean>(false);
  const tabData = ["step1. 방문 목적 설정", "step2. 방문자 수집 정보", "step3. 담당자 설정"];
  const [currentTab, setCurrentTab] = useState<string>("step1. 방문 목적 설정");

  const updateActive = async () => {
    const res = await updateWalkInVisitActive(device.id, !device.isWalkInVisitEnabled);
    if (res) {
      onChange?.();
      setIsOpenAlertModal(false);
    }
  };

  return (
    <div
      css={css`
        height: 80%;
        overflow: auto;
      `}
    >
      <ActiveContainer>
        <div
          css={css`
            display: flex;
            flex-direction: column;
            gap: 4px;
          `}
        >
          <Title>당일 방문 요청 활성화</Title>
        </div>
        <UI.Selection.Toggle.Default
          size="large"
          state={device.isWalkInVisitEnabled}
          onChange={() => {
            setIsOpenAlertModal(true);
          }}
        ></UI.Selection.Toggle.Default>
      </ActiveContainer>

      <>
        <Tab
          onChange={(item) => setCurrentTab(item)}
          data={tabData}
          selected={currentTab}
          styles={{
            container: css`
              padding: 20px 40px 0 40px;
            `,
          }}
        />
        {currentTab === "step1. 방문 목적 설정" && <MeetingPurpose deviceId={device.id} />}
        {currentTab === "step2. 방문자 수집 정보" && <VisitInfoOption deviceId={device.id} />}
        {currentTab === "step3. 담당자 설정" && <SettingManager deviceId={device.id} />}
      </>

      <AlertModal
        title="당일 방문 설정을 변경하시겠습니까?"
        btnTitle="변경하기"
        content={
          <p
            css={css`
              text-align: center;
              color: ${theme.neutral500};
            `}
          >
            해당 옵션을 변경하면,
            <br />
            기존에 설정했던 내역이 사라집니다.
          </p>
        }
        modalIsOpen={isOpenAlertModal}
        closeModal={() => setIsOpenAlertModal(false)}
        onChange={updateActive}
      />
    </div>
  );
};

export default WalkInVisit;
